/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { ProductPermissionModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class EntitlementsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Entitlements
   * @name EntitlementsGet
   * @summary Gets all Entitlements.
   * @request GET:/entitlements
   */
  entitlementsGet = (params: RequestParams = {}) =>
    this.http.request<ProductPermissionModelDto[], any>({
      path: `/entitlements`,
      method: "GET",
      format: "json",
      ...params,
    });
}
